import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useMe } from '../_hooks/me';
import type { AbilityGuardProps } from '../_types/authentication';

export const OrganizationIdsGuard: FC<PropsWithChildren<AbilityGuardProps>> = ({
  children,
  showDenied,
}) => {
  const me = useMe();

  if (me.isPending) {
    return <Loading />;
  }

  return me.data?.organizationIds.length ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
